import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
//import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../UseToken';
import Loader from '../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../ASSEC_CKEditor/ASSEC_CKEditor";

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

//import { List, arrayMove } from "react-movable";;

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
} from '../../Utils';
import Hosts from '../../Hosts';

import { language } from './Language';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [date_creation, set_date_creation] = useState('') 
	const [date_modification, set_date_modification] = useState('') 
	const [/*date_publication*/, set_date_publication] = useState('') 
	const [/*date_avaiable*/, set_date_avaiable] = useState('') 

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	const [, set_menus_avaiable] = useState([])

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);
	//const [save_label, set_save_label] = useState('Salvar');
	//const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)
	const [, setEditorLoaded] = useState(false);
	
	const [, setSelectedFile] = useState(null);

	const [/*treeData*/, setTreeData] = useState([]) 

	const [, set_suggestions] = useState([])

	const [refresh, setRefresh] = useState(0);

	const [files_image, set_files_image] = useState([]);
	
	const [files_doc, set_files_doc] = useState([]);
	const [/*files_doc_name*/, set_files_doc_name] = useState([]);
	
	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				if(res.data[0].info['media'] !== undefined)
					setSelectedFile(res.data[0].info.media)

				let aux = []
				res.data[0].content.forEach((el, k) => {
					if(el.media !== undefined) {
						aux[k] = []
						aux[k][1] = el.media
					}

					if(el['language'] !== undefined && el['language'].length > 0) {
						el['language'].forEach((el_2) => {
							if(el_2 !== undefined && el_2 !== null) {
								if(el_2['media'] !== undefined && el_2['media'] !== null)
									aux[k][el_2.id] = [{image: [], doc: []}]
		
								if(el_2.media !== undefined)
									aux[k][el_2.id] = el_2.media
							}
						})
					}
				})

				//setSelectedFiles(aux)

				let aux_doc = []
				let i = 0
				aux.forEach((el, k) => {
					el.forEach((el_2, k_2) => {
						el_2.doc.forEach((el_3) => {
							if(aux_doc[k] === undefined)
								aux_doc[k] = []
							if(aux_doc[k][k_2] === undefined)
								aux_doc[k][k_2] = []
								
							aux_doc[k][k_2].push({ id: ++i, id_doc: el_3.id, title: el_3.name, link: el_3.link, visible: el_3.visible})
						})
					})
				})
				setTreeData(aux_doc)
				//console.log(res.data[0])
			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const fetch_web_categories = async () => {
		return await reqGET(`${api_crud_base}/web/category/${getTokenInfo().companycode}`)
			.then(res => {
				
				let suggestions_aux = []
				res.data.forEach((el) => {
					suggestions_aux.push({id: el.info.name, text: el.info.name})
				})
				set_suggestions(suggestions_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}


	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.parent = getTokenInfo().id)
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		const order_menu = (parent, array, array2) => {
			let array_aux = array.filter(v => v.info.parent === parent)
			array_aux.forEach(v => {
				array2.push(v)
				order_menu(v.id, array, array2)
			})
		}
	
		const get_menus_avaiable = async () => {
			return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/content`)
				.then(res => {
	
					let array_aux = []
					order_menu('0', res.data, array_aux)
					set_menus_avaiable(array_aux);
					
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		get_menus_avaiable();

		fetch_web_categories()

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				set_show_delete_button(true)

				set_files_doc_name([])

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if(dados.current.info.date.creation !== undefined && dados.current.info.date.creation !== '') {
							let date_creation = new Date(dados.current.info.date.creation); 
							set_date_creation(date_creation.getDate().toString().padStart(2, '0') + '/' + (date_creation.getMonth() + 1).toString().padStart(2, '0') + '/' + date_creation.getFullYear())
						}
						if(dados.current.info.date.published !== undefined && dados.current.info.date.published !== '') {
							let date_publication = new Date(dados.current.info.date.published); 
							set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
						}
						if(dados.current.info.date.avaiable !== undefined && dados.current.info.date.avaiable !== '') {
							let date_avaiable = new Date(dados.current.info.date.avaiable); 
							set_date_avaiable(date_avaiable.getDate().toString().padStart(2, '0') + '/' + (date_avaiable.getMonth() + 1).toString().padStart(2, '0') + '/' + date_avaiable.getFullYear())
						}
						if(dados.current.info.date.modified !== undefined && dados.current.info.date.modified.length > 0) {
							let date_modification = new Date(dados.current.info.date.modified.pop());
							set_date_modification(date_modification.getDate().toString().padStart(2, '0') + '/' + (date_modification.getMonth() + 1).toString().padStart(2, '0') + '/' + date_modification.getFullYear())
						}

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}


	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					change_item_from_menu('title', dados.current.info.name, dados.current.id)
						.then(() => {
							change_item_from_menu('slug', dados.current.info.slug, dados.current.id)
						})

						files_image.forEach(async (el_image) => {
							if(el_image !== null) {
								await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
							}
						})
						set_files_image([])
	
						files_doc.forEach(async (el_doc) => {
							if(el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
							}
						})
						set_files_doc([])
						set_files_doc_name([])

					dados.current.info.date.modified.push(today_submit)
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 

							Swal.fire(language[lang].edit_success, '', 'info')
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit

					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/web/content/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									console.log(res.data)
									dados.current.id = res.data[0].id

									files_image.forEach(async (el_image) => {
										if(el_image !== null) {
											await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
										}
									})
									set_files_image([])

									files_doc.forEach(async (el_doc) => {
										if(el_doc !== null) {
											await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
										}
									})
									set_files_doc([])
									set_files_doc_name([])

									set_is_edit(true)
									set_show_delete_button(true)
								})
								.catch(() => 404)

							Swal.fire(language[lang].insert_success, '', 'info')
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	const remove_menu_childs = (menu, id) => {

		let menu2 = menu.filter(v => v.id_content !== id)
		if(menu2 !== undefined && menu2.length > 0) {
			menu2.forEach((value) => {
				if(value.children !== undefined && value['children'].length > 0) {
					let menu3 = value.children.filter(v => v.id_content !== id)
					if(menu3 !== undefined && menu3.length > 0) {
						return remove_menu_childs(menu3, id)
					}
					else {
						value.children = []
						return value.children
					}
				}
				else {
					return menu2
				} 
			})
		}
		else {
			return menu
		}


	}

	const remove_content_from_menu = async (id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((value) => {
					if(value.content !== undefined && value.content['childs'].length > 0) {

						value.content.childs = value.content.childs.filter(v => v.id_content !== id)
						remove_menu_childs(value.content.childs, id)

						reqPUT(`${api_crud_base}/web/structure`, value)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const change_item_menu_childs = (menu, name, value, id) => {

		if(menu !== undefined && menu.length > 0) {
			menu.forEach((v) => {

				if(v.id_content === id) {
					v[name] = value
				}

				if(v.children !== undefined && v['children'].length > 0) {
					return change_item_menu_childs(v.children, name, value, id)
				}
				else {
					return menu
				} 
			})
		}
		else {
			return menu
		}
	}

	const change_item_from_menu = async (name, value, id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((v) => {
					if(v.content !== undefined && v.content['childs'].length > 0) {

						//console.log(v);
						change_item_menu_childs(v.content.childs, name, value, id)

						reqPUT(`${api_crud_base}/web/structure`, v)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}
	
	const handle_change_content = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)

			if(name === 'title' && order === '0' && is_edit === false) {
				set_dados(dados.current.info.name = value)
				set_dados(dados.current.info.seo.title = value)
			}
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				//dados.current.content[order].language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_notification_date = (e) => {
		const { value } = e.target;

		set_dados(dados.current.info.date['notification'] = value)
		set_dados(dados.current.info['notified'] = false)
	}

	const get_value_content_lang = (order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				return dados.current.content[order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const handle_change_info_seo = (e) => {
		const { name, value } = e.target;

		if(!dados.current.info.seo)
			dados.current.info.seo = {}

		set_dados(dados.current.info.seo[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
        files.forEach(async (element) => {
			if(element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element, order, type, langid, lang)
				   .then(() => {
						//console.log('success')
				   })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

	const uploadFilesDoc = (files, order, type, langid, lang) => {
        let aux = []
        files.forEach((element) => {
			if(element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
				    .then(() => {
						//console.log('success')
				    })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

    const uploadFile = async (file, order, type, langid, lang) => {
        const formData = new FormData()
        formData.append('files', file)
        formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
        formData.append('type', 'content')
        formData.append('companycode', dados.current.info.companycode)
        formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

        return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
            .then((res) => { 
                var today_file = new Date()

                let x = {
                    id: '',
                    info: {
                        companycode: getTokenInfo().companycode,
                        type: res.data.mimetype,
                        link: res.data.path + '/' + res.data.name,
                        size: res.data.size,
                        date: today_file
                    },
					content: {
						name: file.name,
                        description: '',
						lang: []
					}
                }

				if(langid === '1'){
					if(type === 'image') {
						dados.current.content[order]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
					if(type === 'doc') {
						dados.current.content[order]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}
				else {
					if(type === 'image') {
						dados.current.content[order]['language'][langid]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
					if(type === 'doc') {
						dados.current.content[order]['language'][langid]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

                reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => { 

                    })
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))
                
				return true

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }

	const add_content = () => {
		
		dados.current.content.push(data_interface.content[0])
		set_dados(dados.current.content)
		setEditorLoaded(false);
		setRefresh(refresh + 1)

		setTimeout(
            function() { 
				setEditorLoaded(true);
            }
        , 1000);

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].content}</h2>
					<span>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{ dados.current.id !== '' ? language[lang].content_edit : language[lang].content_new }
					</span>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="col-md-8 mb-5 mb-xl-10">
								
								<div className="tab-content" id="tabContent">
									{
									dados.current.info.layout !== 'normal' ?
										<>
											<div className="card mb-3">
												<div className="card-header border-0">
													<ul className="nav nav-tabs nav-line-tabs border-bottom-0 mt-2 mb-1 fs-6">
														<li className="nav-item mb-1 me-1">
															<button type="button" onClick={() => add_content()} className="btn btn-sm btn-secondary rounded-0 multi-item">
																<span>{language[lang].content_add}</span>
															</button>	
														</li>
														{
														dados.current.content.length > 1 ?
															dados.current.content.map((el, k) => {
																return (
																	<li key={k} className="nav-item mb-1">
																		<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_content_" + k}>{k + 1}</a>
																	</li>

																)
															})
														:
															''
														}
													</ul>
												</div>
											</div>
										</>
									:
										null
									}
								
									{
									dados.current.content.map((el, k) => {
										return (
											<div key={k} className={"tab-pane " + (k === 0 ? " show active" : '')} id={"tab_pane_content_" + k} role="tabpanel">

												<div className="card">
													<div className="card-header border-0 d-flex justify-content-sm-between">
														<div className="card-title m-0">
															<h3 className="fw-bolder m-0">{language[lang].content}</h3>
														</div>
														<div className="card-toolbar">
															<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0 d-none">
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<li key={k_lang} className="nav-item">
																				<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																			</li>
																		)
																	})
																:
																	''
																}
															</ul>
														</div>
													</div>
													<div id="div-content" >
														<div className="card-body border-top p-4">
															<div className="tab-content" id={"tabContentLang_" + k} >
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_content_" + k +  "_language_" + k_lang} role="tabpanel">

																			
																				<div className="row mb-5">
																				<div className="col-12 col-sm-4 mb-3">
																						<label className="col-form-label fw-bold fs-6">{language[lang].notification_date}<br/><small>{language[lang].notification_date_help}</small></label>
																						
																						<input type="date" value={dados.current.info.date['notification'] !== undefined ? dados.current.info.date['notification'] : ''} className="form-control form-control-lg mb-3 mb-lg-0 " name="notification" onChange={handle_change_notification_date} />
																					</div>
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6">{language[lang].note}</label>
																						{/* 
																						<CKEditor
																							name={"text-" + k}
																							//value={el.text}
																							value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') }
																							//onChange={(data) => { set_dados(el.text = data) }}
																							onChange={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'text')}
																							editorLoaded={editorLoaded}
																						/> 
																						*/}
																						
																						<AssecCKEditor
																							name={"message-" + k}
																							content={el_lang.id === '1' ? el.message : get_value_content_lang(k, el_lang.id, 'message')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'message')}
																						/>
																						
																						<textarea className="form-control form-control-lg mb-3 mb-lg-0 d-none" name="text" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') } rows="4" onChange={handle_change_content} />
																					</div>
																				</div>
																			</div>
																		)
																	})
																: 
																	''
																}
															</div>
														</div>
													</div>
												</div>
											</div>
											)
										})
									}
								</div>
							</div>

							<div className="col-md-4 mb-5 mb-xl-10">
								<div className="card mb-5">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="div_configuracao">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].table_state}</h3>
										</div>
									</div>
									<div id="div_configuracao" className="collapse show">
										<div className="card-body border-top p-4">

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].dates}</label>
												<p>
													<strong>{language[lang].date_creation}:</strong> {date_creation !== '' ? date_creation : ''}<br />
													<strong>{language[lang].date_last_update}:</strong> {date_modification !== '' ? date_modification : ''}
												</p>
											</div>
										</div>
									</div>
								</div>
								
								<div className="card mb-5 d-none">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_seo" aria-expanded="true" aria-controls="div_seo">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].seo_config}</h3>
										</div>
									</div>
									<div id="div_seo"  className="collapse show">
										<div className="card-body border-top p-4">
											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_title}</label>
												<input type="text" name="title" value={dados.current.info.seo ? dados.current.info.seo.title : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_title_placeholder} onChange={handle_change_info_seo} />
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_keywords} <small>{language[lang].seo_keywords_small}</small></label>
												<input type="text" name="keywords" value={dados.current.info.seo ? dados.current.info.seo.keywords : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_keywords_placeholder} onChange={handle_change_info_seo} />
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_description}</label>
												<textarea type="text" name="description" value={dados.current.info.seo ? dados.current.info.seo.description : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_description_placeholder} onChange={handle_change_info_seo} />
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left">
							</ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										{/*<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>*/}
										<img alt={language[lang].back} src={'./img/seta_2.svg'} />
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>

							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
